/**
 * Peak highlight rules matching zReports unsigned email tables.
 * Yellow (all-time) wins over green (90D) when both match.
 */
export const PEAK_HIGHLIGHT_THRESHOLD = 20

const PEAK_COLUMN_PAIRS = {
  'Daily IG Follower Growth': {
    peak90: '90D Daily IG Growth Peak',
    allTime: 'All-Time Daily IG Growth Peak',
  },
  'Daily TT Follower Growth': {
    peak90: '90D Daily TT Growth Peak',
    allTime: 'All-Time Daily TT Growth Peak',
  },
  'Daily TT Sound Creates Growth': {
    peak90: '90D Daily TT Sound Creates Peak',
    allTime: 'All-Time Daily TT Sound Creates Peak',
  },
  'Daily YT Subs Growth': {
    peak90: '90D Daily YT Growth Peak',
  },
  'Daily Spotify Followers Growth': {
    peak90: '90D Daily Spotify Growth Peak',
  },
}

export const IG_PEAK_COLUMNS = [
  '90D Daily IG Growth Peak',
  'All-Time Daily IG Growth Peak',
]

export const TT_PEAK_COLUMNS = [
  '90D Daily TT Growth Peak',
  'All-Time Daily TT Growth Peak',
]

export const TT_SOUND_PEAK_COLUMNS = [
  '90D Daily TT Sound Creates Peak',
  'All-Time Daily TT Sound Creates Peak',
]

export const YT_PEAK_COLUMNS = ['90D Daily YT Growth Peak']

export const SPOTIFY_PEAK_COLUMNS = ['90D Daily Spotify Growth Peak']

function asNumber(value) {
  if (value === null || value === undefined || value === '') return null
  const n = Number(String(value).replace(/,/g, '').trim())
  return Number.isNaN(n) ? null : n
}

/**
 * @returns {'alltime' | '90d' | null}
 */
export function peakHighlightTone(row, column) {
  const pair = PEAK_COLUMN_PAIRS[column]
  if (!pair || !row) return null

  const daily = asNumber(row[column])
  if (daily === null || daily < PEAK_HIGHLIGHT_THRESHOLD) return null

  const allTime = pair.allTime != null ? asNumber(row[pair.allTime]) : null
  if (allTime !== null && daily === allTime) return 'alltime'

  const peak90 = asNumber(row[pair.peak90])
  if (peak90 !== null && daily === peak90) return '90d'

  return null
}
